import * as GLOBAL_LABELS from "../labels/global";

export const LABELS = {
    [GLOBAL_LABELS.GLOBAL_DELETE]: "削除",
    [GLOBAL_LABELS.GLOBAL_CANCEL]: "キャンセル",
    [GLOBAL_LABELS.GLOBAL_UNKNOWN]: "不明",

    [GLOBAL_LABELS.GLOBAL_TEST_ENVIRONMENT_BANNER_TEST_MODE]: "テストモード",
    [GLOBAL_LABELS.GLOBAL_TEST_ENVIRONMENT_BANNER_LIVE_TEST_MODE]: "本番テストモード",
    [GLOBAL_LABELS.GLOBAL_ENVIRONMENT_MODE_CONFIRMATION_MODAL_MESSAGE]: "※こちらは{mode}のフォームです。実際には決済されませんのでご注意ください。",
    [GLOBAL_LABELS.GLOBAL_ENVIRONMENT_MODE_CONFIRMATION_MODAL_BUTTON]: "了解しました",
};

export default LABELS;
